export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/arabic.9b74e7a.svg";